import type { Config } from '@/config/types.ts';
import merge from 'lodash/merge';
import configDefault from './config-default';
import configDevelopment from './config-development';
import configPreview from './config-preview';
import configProduction from './config-production';
import configRc from './config-rc';
import configTest from './config-test';
import { envEnum } from './env.enum.ts';

type EnvType = typeof envEnum.Type;

const env: EnvType = import.meta.env.VITE_RUN_ENV || envEnum.DEVELOPMENT;

const envConfig = {
  [envEnum.DEVELOPMENT]: configDevelopment,
  [envEnum.TEST]: configTest,
  [envEnum.PRODUCTION]: configProduction,
  [envEnum.PREVIEW]: configPreview,
  [envEnum.RC]: configRc,
}[env];

export const CONFIG = merge({}, configDefault, envConfig) as Config;

export const RUN_ENV: EnvType = env;
export const IS_DEV = env === envEnum.DEVELOPMENT;
export const IS_PREVIEW = env === envEnum.PREVIEW;
export const IS_TEST = env === envEnum.TEST;
export const IS_PROD = env === envEnum.PRODUCTION;
export const IS_RC = env === envEnum.RC;
